import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'containers/App/actions';

const AssignmentItem = ({
  checked,
  name,
  onSave,
  onRemove,
}) => {
  return (
    <div className="ChecklistAssignmentTokenView focus">
      <button
        className="APIconButton"
        name="focus"
        style={{ color: checked ? '#666666' : '#e0e0e0' }}
        onClick={onSave}
      >
        &#x2726;
      </button>
      <span name="label">{name}</span>
      <button
        className="APIconButton"
        name="remove"
        onClick={onRemove}
      >
        x
      </button>
    </div>
  );
};

const ChecklistAssigned = ({
  taskId,
  assignments,
  assignmentOptions,
}) => {
  const dispatch = useDispatch();
  const {
    addTaskAssignment,
    updateTaskAssignment,
    dropaskAssignment,
  } = bindActionCreators(actions, dispatch);

  const userInfo = useSelector((state) => state.global.userInfo);
  const userId = userInfo?.id ?? null;
  const assignableOptions = assignmentOptions.filter(option => !assignments.find(item => item.loginId === option.id));

  const onSaveAssignment = (id, level) => {
    const variables = {
      input: {
        loginId: Number(id),
        focusLevel: level,
      },
      taskId,
    };
    updateTaskAssignment({ variables });
  };

  const onRemoveAssignment = (id) => {
    const variables = {
      loginId: Number(id),
      taskId,
    };
    dropaskAssignment({ variables });
  };

  const onSelectAssignment = (e) => {
    const selected = e.target.value;
    const variables = {
      input: {
        loginId: Number(selected),
        focusLevel: 2,
      },
      taskId,
    };
    addTaskAssignment({ variables });
  };

  return (
    <div name="assignment">
      <div name="label">Assigned:</div>
      <div className="ChecklistAssignmentsView">
        {assignments?.map(assignment => (
          <AssignmentItem
            key={assignment.loginId}
            checked={assignment.focusLevel === 1}
            name={userId === assignment.loginId ? 'Me' : assignment.login.fullname}
            onSave={() => onSaveAssignment(assignment.loginId, assignment.focusLevel === 1 ? 2 : 1)}
            onRemove={() => onRemoveAssignment(assignment.loginId)}
          />
        ))}
        {assignableOptions.length > 0 && (
          <div
            className="ChecklistAssignmentViewSelect placeholder"
            style={{ position: 'relative', display: 'inline-block', overflow: 'hidden' }}
          >
            <span style={{ position: 'absolute', top: '0px', left: '0px', bottom: '0px' }} />
            <select
              style={{ opacity: 0, position: 'relative', zIndex: 1, margin: 0, width: '16px' }}
              onChange={onSelectAssignment}
            >
              <option value="" />
              {assignableOptions.map(option => (
                <option
                  key={option.id}
                  value={option.id}
                >
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChecklistAssigned;
